import styled from 'styled-components';
import Constraint from 'js/components/Constraint';

export default styled(Constraint)`
  margin-top: 2rem;
  text-align: center;
`;
